/**
 * @author Niek Vaanholt <n.vaanholt@bluedragon.nl>
 * @description When page is loaded an study list is found load default the studylist
 */

import { ensureLarouteIsSet } from './_app.js';
import { promiseTimeout } from './_app.js';

const studyList = document.querySelector('.js-study__list');
document.addEventListener('DOMContentLoaded', function() {
    if (studyList) {
        let page = 1;
        const currentUrl = window.location.href;
        const urlParts = currentUrl.split('/');
        if (!isNaN(urlParts[urlParts.length -1])) {
            page = urlParts[urlParts.length -1];
        }
        ensureLarouteIsSet(promiseTimeout).then(function() {
            getStudies(page);
        });
    }
});

const filterStudyCheckboxes = document.querySelectorAll('.js-filter__study');
if (filterStudyCheckboxes) {
    for (let i = 0; i < filterStudyCheckboxes.length; i++) {
        filterStudyCheckboxes[i].addEventListener('change', function() {
            getStudies('1');
        });
    }
}

/**
 * @author Niek Vaanholt <n.vaanholt@bluedragon.nl
 * @description Get the studies
 * @param {number} page
 */
function getStudies(page = 1) {
    const locale = document.querySelector('body').dataset.locale;
    if (!parseInt(page)) {
        page = 1;
    }
    // Get the selected values
    let url = '/' + locale + laroute.route('site.studies.data.index') + '?page=' + page;// eslint-disable-line no-undef
    const checkBoxes = document.querySelectorAll('.js-filter__study:checked');
    if (checkBoxes.length) {
        checkBoxes.forEach((checkbox, index) => {
            url += '&' + checkbox.name + '=' + checkbox.value;
        });
    }

    // Do request
    const request = new XMLHttpRequest();
    request.open('GET', url, true);

    request.onload = function() {
        const studyList = document.querySelector('.js-study__list');
        if (this.status >= 200 && this.status < 400) {
            history.replaceState(
                null,
                null,
                studyList.dataset.route + '/' + page
            );
            studyList.innerHTML = '';
            const result = JSON.parse(this.response);
            result.data.forEach(function(study) {
                studyList.insertAdjacentHTML('beforeEnd', buildStudyAtricleHtml(study));
            });

            const paginationList = document.querySelector('.js-study__pagination-list');
            paginationList.innerHTML = buildPaginationHtml(result.meta);

            const paginationLinks = document.querySelectorAll('.js-pagination__link');
            paginationLinks.forEach((paginationLink) => {
                paginationLink.addEventListener('click', gotoPage);
            });
        }
    };
    request.send();
}

/**
 * @author Niek Vaanholt <n.vaanholt@bluedragon.nl>
 * @description Here we build the study article html
 * @param {object} study
 * @return {string}
 */
function buildStudyAtricleHtml(study) {
    let url = '';
    if (study.url) {
        url = '<a href="' + study.url + '" class="c-study__quick-link c-study__quick-link--web" target="_blank">' +
            '<i class="fas fa-globe-americas"></i>' +
        '</a>';
    }

    let file = '';
    if (study.file) {
        file = '<a href="' + study.file + '" class="c-study__quick-link c-study__quick-link--pdf" target="_blank">' +
            '<i class="fas fa-file-pdf"></i>' +
        '</a>';
    }

    return '<article class="c-study">' +
        url +
        file +
        '<h1 class="c-study__heading">' + study.title + '</h1>' +
        '<span class="c-study__author">' + study.authors + '</span>' +
        '<p>' + study.intro_text + '</p>\n' +
        '<span class="c-study__source">' + study.source + '</span>' +
        '<a href="/studies/' + study.slug + '" class="c-btn c-study__btn">Lees verder</a>' +
    '</article>';
}

/**
 * @author Niek Vaanholt <n.vaanholt@bluedragon.nl>
 * @description Here we build the pagination html
 * @param {object} meta
 * @return {string}
 */
function buildPaginationHtml(meta) {
    let pagination = '';
    let from = 1;
    let to = 5;
    if (meta.current_page > 3) {
        from = (meta.current_page - 2);
        to = (meta.current_page + 2);
    }

    if (to > meta.last_page) {
        to = meta.last_page;
    }

    let previous = 1;
    if (meta.current_page > 1) {
        previous = (meta.current_page - 1);
    }

    let next = meta.last_page;
    if (meta.current_page < meta.last_page) {
        next = (meta.current_page + 1);
    }

    pagination += '<li class="c-pagination__item">' +
        '<a href="#" class="c-pagination__link js-pagination__link" data-page="' + previous + '">' +
            '<i class="fas fa-arrow-left"></i>' +
        '</a>' +
    '</li>';

    for (let page = from; page <= to; page++) {
        let active = '';
        if (page == meta.current_page) {
            active = 'c-pagination__item--active';
        }
        pagination += '<li class="c-pagination__item ' + active + '">' +
            '<a href="#" class="c-pagination__link js-pagination__link" data-page="' + page + '">' +
                page +
            '</a>' +
        '</li>';
    }

    if ((meta.current_page + 2) < meta.last_page && meta.last_page > 4) {
        pagination += '<li class="c-pagination__item"><span class="c-pagination__divider">&hellip;</span></li>';
        pagination += '<li class="c-pagination__item">' +
            '<a href="#" class="c-pagination__link js-pagination__link" data-page="' + meta.last_page + '">' +
                meta.last_page +
            '</a>' +
        '</li>';
    }
    pagination += '<li class="c-pagination__item">' +
        '<a href="#" class="c-pagination__link js-pagination__link" data-page="' + next + '">' +
            '<i class="fas fa-arrow-right"></i>' +
        '</a>' +
    '</li>';
    return pagination;
}

/**
 * @description goto page clicked on
 * @param {number} page
 * @return {boolean}
 */
function gotoPage() {
    getStudies(this.getAttribute('data-page'));
    return false;
}
